const state = {
  tos: [{
    email: '',
    name: '',
  }],
  emailProofingNotes: '',
}

export const requiredFields = [{ key: 'tos' }]

export default state
